angular.module('impactx.productview').controller('ProductViewSuppliersCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ProductViewService',
    'BackService',
    'ToolbarService',
    ProductViewSuppliersCtrl]);

function ProductViewSuppliersCtrl($scope, dataGen, $routeParams, ProductViewService, BackService, ToolbarService) {
    var self = this;
    $scope.url = "supplier";

    dataGen.getData($scope, {id: $routeParams.id}, "/productview/list/suppliers").then(function() {
        $scope.dynamicItems = new DynamicItems();
        defineButtons();
    });

    self.removeItem = function(supplier) {
        ProductViewService.removeSuppliersFromProductView($routeParams.id, [supplier.id]).then(function() {
            $scope.data.relatedSuppliers.splice($scope.data.relatedSuppliers.indexOf(supplier), 1);
        });
    };

    self.removeAllItems = function() {
        var supplierIds = [];
        angular.forEach($scope.data.relatedSuppliers, function(supplier) {
            supplierIds.push(supplier.id);
        });

        return ProductViewService.removeSuppliersFromProductView($routeParams.id, supplierIds).then(function() {
            BackService.back();
        });
    };

    var DynamicItems = function() {
    };

    DynamicItems.prototype.getItemAtIndex = function(index) {
        if($scope.data) {
            return $scope.data.relatedSuppliers[index]
        }
        else {
            return null;
        }
    };

    DynamicItems.prototype.getLength = function() {
        if($scope.data && $scope.data.relatedSuppliers) {
            return $scope.data.relatedSuppliers.length;
        }
        else {
            return 0;
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.removeAll,
                action: self.removeAllItems,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}